import React, { FunctionComponent } from "react";
import ConfirmDialog, { ConfirmDialogProps } from "./ConfirmDialog";

export interface DeleteDialogProps extends Omit<ConfirmDialogProps, "category" | "confirmRes" | "message" | "messageRes" | "messageResParams" | "title" | "titleRes" | "titleResParams"> {
	/** name of node being deleted; if none provided, then type will be used to  */
	nodeName?: string;

	/** localized type of node being deleted */
	typeName: string;
}

const DeleteDialog: FunctionComponent<DeleteDialogProps> = (props) => {
	const {
		nodeName,
		typeName,
		...otherProps
	} = props;

	return (
		<ConfirmDialog
			category="error"
			confirmRes="Delete"
			messageRes={nodeName ? "Delete_Confirm" : "Delete_NoNodeName"}
			messageResParams={[nodeName || typeName.toLocaleLowerCase()]}
			titleRes="Delete_Prompt"
			titleResParams={[typeName]}
			{...otherProps}
		/>
	);
};

export default DeleteDialog;